import React, {useMemo, useState} from 'react';
import {
	useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import PointItemMutateSingleVoyage
	from "@containers/singleVoyage/mutateVoyage/points/pointsList/fullMode/pointItem/PointItemMutateSingleVoyage";
import Box from '@mui/material/Box/Box';
import {sx} from './sx'
import {ReactSortable} from 'react-sortablejs';
import {
	MUTATE_SINGLE_VOYAGE_POINT_SORTABLE_KEY
} from "@containers/singleVoyage/mutateVoyage/points/pointsList/fullMode/constants";
import EmptyLineSingleVoyage from "@containers/singleVoyage/views/stepperLine/line/EmptyLineSingleVoyage";
import SidebarPointMutateSingleVoyage
	from "@containers/singleVoyage/mutateVoyage/points/pointsList/fullMode/sidebar/SidebarPointMutateSingleVoyage";

import {
	useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";
import {
	usePointActionMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/hooks/usePointActionMutateSingleVoyage";
import {IWayPointCreationMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/points/types";
import InputSearch from "@ui/inputs/InputSearch";
import {useTranslation} from 'react-i18next';
import {
	useGetWayPointsMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/hooks/useGetWayPointsMutateSingleVoyage";

import CloseStopsNoticeSingleVoyage
	from "@containers/singleVoyage/containers/closeStops/CloseStopsNoticeSingleVoyage";
import {ICloseStopsConflictSingleVoyage} from "@containers/singleVoyage/containers/closeStops/findCloseStops";
import {IWayPointCreationSingleVoyage} from "@containers/singleVoyage/types/point";
const PointListFullModeMutateSingleVoyage = () => {
	
	const [searchValue, setSearchValue] = useState<string>('')
	
	const {
		targetPointId,
		setPoints,
		routeInfo,
		accountId
	} = useRootContextMutateSingleVoyage()
	
	
	const waypoints = useGetWayPointsMutateSingleVoyage()
	const {mode,} = useViewContextMutateSingleVoyage()
	const {t} = useTranslation()
	
	const {
		onSort,
		onClickPoint,
		onDelete,
		isLoading,
	} = usePointActionMutateSingleVoyage()
	
	const onRemoveCloseStop = (point: IWayPointCreationSingleVoyage, index: number) => {
		const stop = waypoints?.find((item) => item.id?.toString() === point.id?.toString())
		if (stop) {
			onDelete({point: stop, index})
		}
	}

	// Both stops get at most the radius that keeps a vehicle standing at one out of the other zone
	const onResizeCloseStops = (conflict: ICloseStopsConflictSingleVoyage) => {
		const ids = [conflict.first.id?.toString(), conflict.second.id?.toString()]
		setPoints((prev) => prev.map((point) => ids.includes(point.id?.toString())
			? {...point, radius: Math.min(point.radius, conflict.maxRadius)}
			: point))
	}

	const pointsWithSearch: IWayPointCreationMutateSingleVoyage[] = useMemo(() => {
		if (!waypoints?.length) {
			return []
		}
		if (!searchValue) {
			return waypoints
		}
		return waypoints.filter((point) => {
			return point?.name?.toLowerCase().includes(searchValue.toLowerCase())
		})
	}, [searchValue, waypoints])
	const list = pointsWithSearch?.length >= 1 && pointsWithSearch.map((point, index) => {
		return (
			<PointItemMutateSingleVoyage
				point={point}
				key={point.id}
				index={index}
				onDelete={onDelete}
				disabled={isLoading || mode !== 'points'}
				onClickPoint={onClickPoint}
				active={targetPointId?.toString() === point.id?.toString()}
				voyageStatus={routeInfo.status}
				accountId={accountId}
			/>
		)
	})
	
	
	return (
		<Box
			sx={sx.root}
		>
			{!waypoints?.length && <EmptyLineSingleVoyage
                sx={sx.line}
            />}

			<CloseStopsNoticeSingleVoyage
				disabled={isLoading || mode !== 'points'}
				onShow={onClickPoint}
				onRemove={onRemoveCloseStop}
				onResize={onResizeCloseStops}
			/>
			
			
			<Box
				sx={sx.wrapper}
			>
				<InputSearch
					onChange={setSearchValue}
					hasDebounce
					value={searchValue}
					label={t('base.searchByName')}
				/>
			</Box>
			
			<ReactSortable
				animation={200}
				list={waypoints}
				setList={setPoints}
				onSort={onSort}
				handle={`.${MUTATE_SINGLE_VOYAGE_POINT_SORTABLE_KEY}`}
				forceFallback
				scroll
				scrollSensitivity={100}
				scrollSpeed={10}
			>
				{list}
			</ReactSortable>
			
			<SidebarPointMutateSingleVoyage/>
		
		</Box>
	);
};

export default PointListFullModeMutateSingleVoyage;
